const REACT_APP_API = process.env.REACT_APP_API_KEY;

const REACT_URL = 'https://fortniteapi.io/v2/shop?lang=ru';

export {
  REACT_APP_API,
  REACT_URL
}